interface StatusBadgeProps {
  status: string;
}

// Mapea estados conocidos a un color; cualquier valor desconocido cae a neutral.
const TONE: Record<string, string> = {
  active: 'badge-green',
  trial: 'badge-amber',
  suspended: 'badge-red',
  suspendido: 'badge-red',
  inactive: 'badge-red',
};

/** Etiqueta de estado del tenant. */
export function StatusBadge({ status }: StatusBadgeProps) {
  const tone = TONE[status.toLowerCase()] ?? 'badge-neutral';
  return <span className={`badge ${tone}`}>{status}</span>;
}
